export default __webpack_public_path__ + "static/media/138.fd36f984.png";